import React, { forwardRef, type HTMLAttributes } from "react";
import { Link } from "react-router-dom";
import { cn } from "../lib/utils";
import { Menu } from "lucide-react";

export interface BreadcrumbItem { label: string; href?: string; }

export interface TopbarProps extends HTMLAttributes<HTMLDivElement> {
  title: string;
  actions?: React.ReactNode;
  onMenuToggle?: () => void;
  breadcrumbs?: BreadcrumbItem[];
}

const Topbar = forwardRef<HTMLDivElement, TopbarProps>(
  ({ className, title, actions, onMenuToggle, breadcrumbs, ...props }, ref) => (
    <header ref={ref} className={cn("flex h-16 items-center justify-between border-b border-border bg-background/80 backdrop-blur-md sticky top-0 z-50 px-4 lg:px-6", className)} {...props}>
      <div className="flex items-center gap-3">
        {onMenuToggle && (
          <button onClick={onMenuToggle} aria-label="Alternar menu" data-i18n-attr='{"aria-label":"common.toggleMenu"}' className="inline-flex items-center justify-center rounded-md p-1.5 text-muted-foreground hover:bg-muted lg:hidden">
            <Menu className="h-5 w-5" />
          </button>
        )}
        {breadcrumbs && breadcrumbs.length > 0 && (
          <nav aria-label="Navegação estrutural" data-i18n-attr='{"aria-label":"common.breadcrumb"}' className="hidden items-center gap-1.5 text-sm sm:flex">
            {breadcrumbs.map((item, index) => (
              <React.Fragment key={index}>
                {index > 0 && <span className="text-muted-foreground">/</span>}
                {item.href ? <Link to={item.href} className="text-muted-foreground hover:text-foreground transition-colors">{item.label}</Link> : <span className="font-medium text-foreground">{item.label}</span>}
              </React.Fragment>
            ))}
          </nav>
        )}
        <h3 className="text-lg font-semibold text-primary">{title}</h3>
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </header>
  ),
);
Topbar.displayName = "Topbar";

export { Topbar };
